import { render, staticRenderFns } from "./downloadReceivableDocuments.vue?vue&type=template&id=6a2607fc&scoped=true&"
import script from "./downloadReceivableDocuments.vue?vue&type=script&lang=js&"
export * from "./downloadReceivableDocuments.vue?vue&type=script&lang=js&"
import style0 from "./downloadReceivableDocuments.vue?vue&type=style&index=0&id=6a2607fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2607fc",
  null
  
)

export default component.exports